// extracted by mini-css-extract-plugin
module.exports = {"root":"_4f720283bf--root--P5HDA"};